import { handleErrors } from './AssetController'

export const getPayments = async (address) => {
    const url = `${process.env.REACT_APP_NFT_SERVICE}owners/payments/${address}`
    return fetch(url)
        .then(handleErrors)
        .then((res) => res.json())
        .then((payments) => {
            return payments
        })
}

export const getShareEvents = async (address) => {
    const url = `${process.env.REACT_APP_NFT_SERVICE}owners/shares/${address}`
    return fetch(url)
        .then(handleErrors)
        .then((res) => res.json())
        .then((events) => {
            return events
        })
}

/**
 * This only works for a token owner.
 * 
 * Get the shares object for a specific Owner and tokenId within shares. If found it is:
 *      eventType: { type: Number },
        tokenOwner: { type: String },
        tokenId: { type: String },
        numShares: { type: Number },
        pricePerShare: { type: Number },
        txHash: { type: String },
        received: { type: Date, default: Date.now },
 * @param {*} address Owner address
 * @param {*} tokenId 
 * @returns 
 */
export const getSharesForToken = async (address, tokenId) => {
    const url = `${process.env.REACT_APP_NFT_SERVICE}owners/tokenShares/${address}/${tokenId}`
    return fetch(url)
        .then(handleErrors)
        .then((res) => res.json())
        .then((shares) => {
            return shares
        })
}